import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  saved: false,
  menu: []
};

const getters = {
  menu: state => {
    return state.menu;
  },
};

const actions = {
  save({ commit }, { menu }) {
    commit('saveRequest');
    try {
      commit('save', menu);
      return true;
    } catch (e) {
      throw e;
    }
  },
};

const mutations = {
  saveRequest(state) {
    state.saved = false;
    state.menu = [];
  },
  save(state, menu) {
    state.saved = true;
    state.menu = menu;
  },
};


const menu = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default menu;

export { menu };

